import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import '../../css/general.css'
import '../../css/inventory.css';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { OperationType } from '../../Constants/StorageConstants';

const StorageSection = (props) => {
    const { t } = useTranslation();
    const [selectedQuality, setSelectedQuality] = useState(null);
    const storageOptions = [
        { label: t('Inventory_Seeds'), value: OperationType.Seeds },
        { label: t('Inventory_Fertilizers'), value: OperationType.Fertilizers },
        { label: t('Inventory_Pesticides'), value: OperationType.Pesticides },
    ];

    useEffect(() => {

    }, []);

    const updateOperationType = (value) => {
        // Update context values
        var updateObject = {
            type: 'UPDATE',
            purchaseObject: {
                operationType: value
            },
            sectionValidation: {
                storageSection: true
            }
        };
        props.updatePurchaseObject(updateObject);
    }

    return (
        <>
            <Form.Group controlId="storage">
                <Form.Label className="text-dark purchase-section-header">{t('Storage')}</Form.Label>
                <ButtonGroup data-toggle="buttons">
                    {storageOptions.map((radio, i) => (
                        <ToggleButton
                            key={radio.label + i}
                            id={radio.label + i}
                            type="radio"
                            variant="outline-success"
                            name={radio.label + i}
                            value={radio.value}
                            checked={selectedQuality === radio.value}
                            onChange={(e) => {
                                // Cast to number
                                var value = Number(e.currentTarget.value);
                                setSelectedQuality(value);
                                updateOperationType(value);
                            }}
                        >
                            {radio.label}
                        </ToggleButton>
                    ))}
                    </ButtonGroup>
            </Form.Group>
        </>
    )
}

export default StorageSection;